<template>
  <div style="background:#F9FBFC;">
    <div class="top-nav">
      <img src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/inventory/inventory_logo.png" alt="no" transcolor="#FFFFFF" style="width: 140px;height: 40px;">
      <div class="btn_div">
        <div class="print-btn" @click="printBtn('all')">打印全部</div>
      </div>
    </div>

    <div v-if="loading" class="no-content">正在加载中...</div>
    <block v-else>
      <div v-if="listData.length > 0" class='container' id="container" style="margin: 17px 10%;padding-top:100px;">
        <!-- 遍历的数据 -->
        <div :id="'main'+ item.logistics_id" v-for="(item, index) in listData" :key="index" style="padding-bottom:100px;background:#fff;margin-bottom:16px;padding:24px 5% 146px;border: 1px solid #E6EBEF;border-radius: 1px;">
          <!-- 头部 -->
          <div class='header' style="display:flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center; ">
              <img src="https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/purchase/inventory_logo_one.png" alt="no" style="width: 140px;height: 36.2px;">
              <div class='split_line' style="height: 26px;border: 1px solid #535961;margin: 0 10px;"></div>
              <div class='location_name' style="font-size: 20px;color: #2a2d37;">{{cityWarehouse.city_warehouse_name}}</div>
            </div>
            <div class="print-btn" :id="'print-btn' + item.logistics_id" @click="printBtn(item)">打印</div>
          </div>
          <div class='header_border' style=" width: 100%;opacity: 0.3;border-bottom: 1px solid #535961;margin-top: 16px;"></div>
          <div class='header_border_two' style="width: 100%;opacity: 0.3;border-bottom: 2px solid #535961;margin-top: 2px;"></div>

          <!-- 标题 -->
          <div class='title' style="font-size: 30px;color: #2a2d37;text-align: center;padding: 20px 0 20px;">{{item.city_warehouse_name}}提货单</div>

          <!-- 提货单信息 -->
          <div style="text-align:center;font-size:15px;color:#2a2d37;">
            <div style="margin-bottom:15px;">发货日期：{{item.l_create_date}}</div>
          </div>

          <!-- 表格 -->
          <table cellspacing="0" :style="bgcolor" class="table" style="width:100%;border-left: 1px solid #535961;">
            <tr>
              <th class="th" v-for="(val, idx) in column" :style="{'width': val.width || 0}" :key="idx" style="height:40px;background: #f9fafb;text-align: center;border-right: 1px solid #535961;border-bottom: 1px solid #535961;border-top:1px solid #535961;font-size:14px;">{{ val.label }}</th>
            </tr>

            <tr v-for="(val, idx) in item.tableData" :key="idx">
              <td v-for="(context, i) in column" :key="i" style="height:35px;line-height:20px;padding:4px 4px 6px;text-align: center;border-right: 1px solid #535961;border-bottom: 1px solid #535961;font-size:14px;">{{ val[context.dataIndex] }}</td>
            </tr>

          </table>
          <div class='uers_info' style="margin-top: 20px;font-size: 14px; color: rgb(42, 45, 55);display: flex;align-items: center;justify-content: space-between;margin-bottom: 15px;">温馨提示：收到货物后，请您现场验货，如有差异向站长提出，一旦签收，我们将不再受理此退换要求。</div>
        </div>
      </div>
      <div v-else-if="listData.length == 0" class="no-content">暂无数据</div>
    </block>
  </div>
</template>


<script>
import { toRefs, reactive, onMounted } from "vue";
import { Toast } from "vant";
import { getLodop } from "@/utils/LodopFuncs";
import { get } from "@/request/http.js";

export default {
  components: {},

  setup() {
    const state = reactive({
      LODOP: null,
      city_warehouse_id: "", // 城市仓ID
      cityWarehouse: {},//
      listData: [], // 列表数据
      // 表头
      column: [
        { label: "序号", dataIndex: "serialNumber", width: "10%" },
        { label: "商品ID", dataIndex: "roomType", width: "15%" },
        { label: "商品名称", dataIndex: "closedAccount", width: "20%" },
        { label: "重量(kg)", dataIndex: "noAccount", width: "15%" },
        { label: "数量", dataIndex: "totalPrice", width: "15%" },
      ],
      loading: false,
    });
    onMounted(() => {
      // #/bill_lading?city_warehouse_id=390088190737776640
      if (window.location.hash.split("?")[1].split("=")[1]) {
        state.city_warehouse_id = window.location.hash
            .split("?")[1]
            .split("=")[1];
      }

      getlistData(); // 获取提货单列表
    });

    // 提货单列表
    const getlistData = () => {
      state.loading = true;
      const params = { city_warehouse_id: state.city_warehouse_id };
      // const params = {city_warehouse_id: '410258173316825088'};
      // get("https://h5.allengoods.com/api/pur-picking/self-delivery-bill-warehouse", params).then((res) => {
      get("/api/pur-picking/self-delivery-bill-warehouse", params).then((res) => {
        // console.log("列表数据", res.data.data);
        if (res.data.code == 200) {
          setTimeout(() => {
            state.loading = false;
          }, 300);
          if (res.data.data && res.data.data.list.length > 0) {
            res.data.data.list.map((item) => {
              // 表格数据
              let arr = [];
              if (item.product.length > 0) {
                // 假数据
                // let flag = [];
                // for (let i = 0; i < 40; i++) {
                //   flag.push(item.product[0]);
                // }
                // item.product = flag;
                // ---------------

                item.product.map((val, index) => {
                  if (val.product_name.length >= 30) {
                    val.product_name =
                        val.product_name.substring(0, 30) + "...";
                  }
                  arr.push({
                    serialNumber: index + 1, // 序号
                    roomType: val.product_sku_sn, // 商品ID
                    closedAccount: val.product_name, // 商品名称
                    noAccount: val.weight_kg, // 重量(kg)
                    totalPrice: val.quantity, // 数量
                  });
                });
              }
              item.tableData = arr;
            });

            state.listData = res.data.data.list; // 列表数据
            state.cityWarehouse = res.data.data.city_warehouse; // 城市仓信息
          }
        }
      });
    };

    // 打印
    const printBtn = (args) => {
      if (state.listData.length <= 0) {
        Toast("暂无打印数据");
        return;
      }
      createOneFormPage(args);
      state.LODOP.PRINT_SETUP();
    };

    const createOneFormPage = (args) => {
      state.LODOP = getLodop(); // 调用getLodop获取LODOP对象
      state.LODOP.PRINT_INIT("提货单"); //打印任务名

      if (args == 'all') {
        // 批量打印
        for (let i = 0; i < state.listData.length; i++) {
          document.getElementById('print-btn' + state.listData[i].logistics_id).style.visibility = "hidden";
          state.LODOP.NewPageA(); // 另起一页
          const strFormHtml = document.getElementById("main" + state.listData[i].logistics_id).innerHTML;
          state.LODOP.ADD_PRINT_HTM(
              "7mm",
              40,
              "RightMargin:0.9cm",
              "BottomMargin:7mm",
              strFormHtml
          );

          setTimeout(() => {
            document.getElementById('print-btn' + state.listData[i].logistics_id).style.visibility = "visible";
          }, 1000)
        }
      } else if (args.logistics_id) {
        state.LODOP.NewPageA(); // 另起一页
        document.getElementById('print-btn' + args.logistics_id).style.visibility = "hidden";
        const strFormHtml = document.getElementById("main" + args.logistics_id).innerHTML;
        state.LODOP.ADD_PRINT_HTM(
            "7mm",
            40,
            "RightMargin:0.9cm",
            "BottomMargin:7mm",
            strFormHtml
        );

        setTimeout(() => {
          document.getElementById('print-btn' + args.logistics_id).style.visibility = "visible";
        }, 1000)
      }

      // 创建页码 每页都有
      // state.LODOP.ADD_PRINT_HTM(
      //   1046,
      //   310,
      //   300,
      //   100,
      //   "总页号：<font color='#2a2d37' format='ChineseNum'><span tdata='pageNO'>第##页</span>/<span tdata='pageCount'>共##页</span></font>"
      // );
      // state.LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      // state.LODOP.SET_PRINT_STYLEA(0, "Horient", 1);

      // lodop打印表格太长被自动分为几页,但页头或页尾会缺失一根横线,有时一行数据被分到两页(暂时没用)
      // state.LODOP.SET_PRINT_STYLEA(0, "TableRowThickNess", 25);  // 后面的参数可以设置成合适的大小即可;

      // state.LODOP.PRINT(); // 打印
      state.LODOP.PREVIEW(); // 预览
    };

    return {
      printBtn,
      createOneFormPage,
      getlistData,
      ...toRefs(state),
    };
  },
};
</script>

<style id="style1">
.top-nav {
  height: 71px;
  background: #ffffff;
  padding: 0 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 6;
}
.print-btn {
  width: 88px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #316af6;
  cursor: pointer;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  float: right;
}
td:nth-child(3) {
  height: 25px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.no-content {
  font-size: 28px;
  color: #2a2d37;
  text-align: center;
  margin-top: 71px;
  padding: 200px 0;
  background: #fff;
  border-top: 1px solid #e6ebef;
}
.btn_div{
  width: 240px;
  /*display: flex;*/
  /*justify-content: space-between;*/
}
.second_btn{
  width: auto;
  text-align: center;
  background: orange;
  cursor: pointer;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  padding: 11px 15px;
  box-sizing: border-box;
  float: left;
}
/* .container {
  width: 756px;
  height: 1086px;
  margin: 0 auto;
  padding: 25px 15px 20px;
}

.header {
  display: flex;
  align-items: center;
}

.header img {
  width: 140px;
  height: 40px;
}

.split_line {
  width: 0.5px;
  height: 26px;
  border: 1px solid #535961;
  margin: 0 10px;
}

.location_name {
  font-size: 20px;
  color: #2a2d37;
}

.header_border {
  width: 100%;
  opacity: 0.3;
  border-bottom: 1px solid #535961;
  margin-top: 16px;
}

.header_border_two {
  width: 100%;
  opacity: 0.3;
  border-bottom: 2px solid #535961;
  margin-top: 2px;
}

.title {
  font-size: 30px;
  color: #2a2d37;
  text-align: center;
  padding: 30px 0 20px;
}

.uers_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  font-size: 15px;
  color: #2a2d37;
}

.table {
  width: 100%;
  border: 1px solid #535961;
  border-bottom: none;
}

.th {
  height: 40px;
  background: #f9fafb;
  text-align: center;
  border-right: 1px solid #535961;
  border-bottom: 1px solid #535961;
}

.th:last-child {
  border-right: none;
}

td {
  padding: 10px;
  text-align: center;
  border-right: 1px solid #535961;
  border-bottom: 1px solid #535961;
}

td:nth-child(2) {
  height: 25px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

td:last-child {
  border-right: none;
} */
</style>

